// extracted by mini-css-extract-plugin
export default {"HomePage":"AwesomeHome_HomePage__WxZCS"};